import { createTheme } from "@mui/material/styles";

// Custom DataGrid theme with consistent styling
export const dataGridTheme = {
  border: "1px solid #000",
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #e0e0e0",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f5f5f5",
    borderBottom: "2px solid #000",
  },
  "& .MuiDataGrid-columnHeader": {
    fontWeight: 700,
    fontSize: "0.875rem",
    color: "#000",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #e0e0e0",
  },
  "& .MuiDataGrid-root": {
    border: "1px solid #000",
  },
  "& .MuiDataGrid-main": {
    border: "1px solid #000",
  },
};

// Alternative theme with maroon headers (for future use)
export const dataGridThemeMaroon = {
  border: "1px solid #000",
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #e0e0e0",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#500000",
    borderBottom: "2px solid #000",
  },
  "& .MuiDataGrid-columnHeader": {
    fontWeight: 700,
    fontSize: "0.875rem",
    color: "#fff",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #e0e0e0",
  },
  "& .MuiDataGrid-root": {
    border: "1px solid #000",
  },
  "& .MuiDataGrid-main": {
    border: "1px solid #000",
  },
};

// Theme with no borders (for future use)
export const dataGridThemeNoBorder = {
  border: "none",
  "& .MuiDataGrid-cell": {
    borderBottom: "1px solid #e0e0e0",
    fontSize: "0.875rem",
  },
  "& .MuiDataGrid-columnHeaders": {
    backgroundColor: "#f5f5f5",
    borderBottom: "2px solid #e0e0e0",
  },
  "& .MuiDataGrid-columnHeader": {
    fontWeight: 700,
    fontSize: "0.875rem",
    color: "#000",
  },
  "& .MuiDataGrid-footerContainer": {
    borderTop: "1px solid #e0e0e0",
  },
};

// Default DataGrid configuration
export const dataGridConfig = {
  pageSize: 25,
  rowsPerPageOptions: [10, 25, 50, 100],
  disableSelectionOnClick: true,
  disableColumnMenu: true,
  hideFooterSelectedRowCount: true,
};

// Common column configurations
export const columnConfigs = {
  patientName: {
    field: "patientName",
    headerName: "Participant Name",
    width: 200,
  },
  dateOfBirth: {
    field: "dateOfBirth",
    headerName: "Date of Birth",
    width: 150,
  },
  studyId: {
    field: "studyId",
    headerName: "Study ID(s)",
    width: 200,
  },
  surveyType: {
    field: "surveyType",
    headerName: "Survey Type",
    width: 150,
  },
  action: {
    field: "action",
    headerName: "Action",
    width: 200,
  },
  actionWide: {
    field: "action",
    headerName: "Action",
    width: 300,
  },
};
